/* Meridian commerce: the bag flyout, Add to Bag, quick add and its options
   sheet, predictive search, and recording recently viewed products.
   Plain JavaScript; every form still works without it. */
(function () {
  'use strict';

  var R = window.MeridianRoutes || {};
  var T = window.MeridianStrings || {};
  var BAG = 'bag-panel';
  var RV_KEY = 'meridian:recently-viewed';
  var ICON_CLOSE = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8"/></svg>';

  function $(s, root) { return (root || document).querySelector(s); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function joinRoot(path) { return (R.root || '/').replace(/\/?$/, '/') + path.replace(/^\//, ''); }

  function post(url, body) {
    var isForm = body instanceof FormData;
    return fetch(url, {
      method: 'POST',
      headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: isForm ? body : JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || T.error);
        return data;
      });
    });
  }

  function toast(message) {
    var t = $('[data-toast]');
    if (!t) {
      t = document.createElement('div');
      t.className = 'toast';
      t.setAttribute('data-toast', '');
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.textContent = message;
    t.dataset.show = 'true';
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.dataset.show = 'false'; }, 3200);
  }

  /* ---------- bag ---------- */
  function renderBag(sections) {
    if (!sections || !sections[BAG]) return refreshBag();
    var doc = new DOMParser().parseFromString(sections[BAG], 'text/html');
    var body = doc.querySelector('[data-bag-body]');
    var slot = $('[data-bag-slot]');
    if (!body || !slot) return;
    slot.innerHTML = body.outerHTML;
    var count = parseInt(body.getAttribute('data-count'), 10) || 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    var checkout = $('[data-bag-checkout]');
    if (checkout) checkout.hidden = count === 0;
    document.dispatchEvent(new CustomEvent('meridian:cart', { detail: { count: count } }));
  }

  function refreshBag() {
    return fetch(joinRoot('?sections=' + BAG))
      .then(function (r) { return r.json(); })
      .then(function (sections) { if (sections && sections[BAG]) renderBag(sections); });
  }

  function openBag() {
    if (window.Meridian && window.Meridian.openPanel) window.Meridian.openPanel('bag');
  }

  function addToBag(payload) {
    if (payload instanceof FormData) {
      payload.append('sections', BAG);
      payload.append('sections_url', window.location.pathname);
    } else {
      payload.sections = BAG;
      payload.sections_url = window.location.pathname;
    }
    return post(R.cartAdd + '.js', payload).then(function (data) {
      renderBag(data.sections);
      // On the bag page itself the page is the bag: reload rather than overlay.
      if (document.body.classList.contains('template-cart')) window.location.reload();
      else openBag();
      return data;
    });
  }

  function changeLine(key, quantity) {
    return post(R.cartChange + '.js', {
      id: key, quantity: quantity, sections: BAG, sections_url: window.location.pathname
    }).then(function (cart) {
      renderBag(cart.sections);
      if (document.body.classList.contains('template-cart')) window.location.reload();
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bag-slot] [data-qty-step], [data-bag-slot] [data-qty-set]');
    if (!btn) return;
    var line = btn.closest('[data-line-key]');
    if (!line || line.getAttribute('aria-busy') === 'true') return;
    var qty = btn.hasAttribute('data-qty-set')
      ? parseInt(btn.getAttribute('data-qty-set'), 10)
      : parseInt(line.dataset.qty, 10) + parseInt(btn.getAttribute('data-qty-step'), 10);
    line.setAttribute('aria-busy', 'true');
    changeLine(line.dataset.lineKey, Math.max(0, qty)).catch(function (err) {
      line.removeAttribute('aria-busy');
      toast(err.message);
    });
  });

  // Notes save as they are typed, so the note is on the order whichever
  // checkout button the customer ends up pressing.
  var noteTimer;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cart-note]')) return;
    var value = e.target.value;
    document.querySelectorAll('[data-cart-note]').forEach(function (el) { if (el !== e.target) el.value = value; });
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { post(R.cartUpdate + '.js', { note: value }).catch(function () {}); }, 400);
  });

  /* ---------- Add to Bag on the product page ---------- */
  function busy(btn, on) {
    if (!btn) return;
    btn.setAttribute('aria-busy', String(on));
    btn.disabled = on;
    if (on) { btn.dataset.idleLabel = btn.textContent; btn.textContent = T.adding; }
    else if (btn.dataset.idleLabel) { btn.textContent = btn.dataset.idleLabel; }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-product-form]')) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-button]');
    var errorEl = form.querySelector('[data-form-error]');
    if (errorEl) errorEl.hidden = true;
    busy(btn, true);
    addToBag(new FormData(form))
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        else toast(err.message);
      })
      .then(function () { busy(btn, false); });
  });

  /* ---------- quick add ---------- */
  document.addEventListener('click', function (e) {
    /* The whole accessories shelf in one go, the way Apple's attach step lets
       you take the lot. One write carrying every variant, so the bag opens
       once with Shopify's own total rather than this script adding prices up
       and risking a figure the checkout then disagrees with. */
    var b = e.target.closest('[data-bundle-add]');
    if (b && b.getAttribute('aria-busy') !== 'true') {
      e.preventDefault();
      var ids = (b.dataset.variantIds || '').split(',').map(function (n) {
        return parseInt(n, 10);
      }).filter(function (n) { return n > 0; });
      if (!ids.length) return;
      b.setAttribute('aria-busy', 'true');
      addToBag({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
        .then(function () {
          b.classList.add('is-added');
          setTimeout(function () { b.classList.remove('is-added'); }, 1600);
        })
        .catch(function (err) { toast(err.message); })
        .then(function () { b.removeAttribute('aria-busy'); });
      return;
    }

    var q = e.target.closest('[data-quick-add]');
    if (!q || q.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    if (q.dataset.variantId) {
      q.setAttribute('aria-busy', 'true');
      addToBag({ items: [{ id: parseInt(q.dataset.variantId, 10), quantity: 1 }] })
        .then(function () {
          q.classList.add('is-added');
          setTimeout(function () { q.classList.remove('is-added'); }, 1600);
        })
        .catch(function (err) { toast(err.message); })
        .then(function () { q.removeAttribute('aria-busy'); });
    } else if (q.dataset.productUrl) {
      openSheet(q.dataset.productUrl, q);
    }
  });

  /* ---------- options sheet ---------- */
  var sheet;
  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('dialog');
    sheet.className = 'sheet';
    sheet.setAttribute('data-sheet', '');
    sheet.setAttribute('aria-labelledby', 'SheetTitle');
    document.body.appendChild(sheet);
    // A click on the backdrop lands on the dialog element itself.
    sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });
    sheet.addEventListener('close', function () { if (sheet._opener) sheet._opener.focus(); });
    return sheet;
  }

  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }
  function sized(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function openSheet(url, opener) {
    var d = ensureSheet();
    d._opener = opener;
    opener.setAttribute('aria-busy', 'true');
    fetch(url + '.js')
      .then(function (r) { if (!r.ok) throw new Error(T.error); return r.json(); })
      .then(function (p) {
        var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        var groups = (p.options || []).map(function (o, i) {
          var name = typeof o === 'string' ? o : o.name;
          var values = (typeof o === 'object' && o.values) ? o.values : p.variants
            .map(function (v) { return v.options[i]; })
            .filter(function (v, idx, arr) { return arr.indexOf(v) === idx; });
          return '<fieldset class="sheet__opt"><legend>' + esc(name) + '</legend><div class="sheet__chips">' +
            values.map(function (val, j) {
              var id = 'SheetOpt-' + i + '-' + j;
              return '<input type="radio" id="' + id + '" name="sheet-opt-' + i + '" value="' + esc(val) + '"' +
                (first.options[i] === val ? ' checked' : '') + '><label for="' + id + '">' + esc(val) + '</label>';
            }).join('') + '</div></fieldset>';
        }).join('');

        d.innerHTML =
          '<form method="dialog"><button class="sheet__close" aria-label="' + esc(T.close) + '">' + ICON_CLOSE + '</button></form>' +
          '<div class="sheet__body">' +
            '<div class="sheet__art" data-sheet-art></div>' +
            '<div class="sheet__info">' +
              '<h2 id="SheetTitle" class="sheet__title">' + esc(p.title) + '</h2>' +
              '<p class="sheet__price tnum" data-sheet-price></p>' + groups +
              '<button class="btn btn--lg btn--block" type="button" data-sheet-add></button>' +
              '<p class="form-error" role="alert" data-sheet-error hidden></p>' +
              '<a class="arrowlink sheet__more" href="' + esc(url) + '">' + esc(T.viewDetails) + ' <span class="chev">&rsaquo;</span></a>' +
            '</div>' +
          '</div>';

        function selectedVariant() {
          var sel = (p.options || []).map(function (_, i) {
            var c = d.querySelector('input[name="sheet-opt-' + i + '"]:checked');
            return c ? c.value : null;
          });
          return p.variants.filter(function (v) {
            return v.options.every(function (x, i) { return x === sel[i]; });
          })[0];
        }
        function sync() {
          var v = selectedVariant();
          var add = d.querySelector('[data-sheet-add]');
          d.querySelector('[data-sheet-price]').textContent = v ? money(v.price) : '';
          add.disabled = !v || !v.available;
          add.textContent = v && v.available ? T.addToBag : T.soldOut;
          var img = (v && v.featured_image && v.featured_image.src) || p.featured_image;
          d.querySelector('[data-sheet-art]').innerHTML = img ? '<img src="' + esc(sized(img, 700)) + '" alt="">' : '';
        }
        d.onchange = sync;
        d.querySelector('[data-sheet-add]').addEventListener('click', function () {
          var v = selectedVariant();
          if (!v) return;
          var btn = this;
          var err = d.querySelector('[data-sheet-error]');
          err.hidden = true;
          busy(btn, true);
          addToBag({ items: [{ id: v.id, quantity: 1 }] })
            .then(function () { d._opener = null; d.close(); })
            .catch(function (e2) { err.textContent = e2.message; err.hidden = false; busy(btn, false); sync(); });
        });
        sync();
        d.showModal();
      })
      .catch(function (err) { toast(err.message); })
      .then(function () { opener.removeAttribute('aria-busy'); });
  }

  /* ---------- predictive search ---------- */
  function initSearch() {
    var input = $('[data-search-input]');
    if (!input || input.dataset.wired) return;
    input.dataset.wired = '1';
    var results = $('[data-search-results]');
    var live = $('[data-search-live]');
    var fallback = $('[data-search-default]');
    var clear = $('[data-search-clear]');
    var controller, timer;

    function reset() {
      live.innerHTML = '';
      fallback.hidden = false;
      input.setAttribute('aria-expanded', 'false');
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (clear) clear.hidden = !input.value;
      clearTimeout(timer);
      if (!q) { if (controller) controller.abort(); reset(); return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = R.predictiveSearch + '?q=' + encodeURIComponent(q) +
          '&section_id=predictive-search' +
          '&resources[type]=product,collection,query' +
          '&resources[limit]=6' +
          '&resources[limit_scope]=each' +
          '&resources[options][unavailable_products]=last';
        fetch(url, { signal: controller.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var found = doc.querySelector('[data-predictive]');
            if (!found || input.value.trim() !== q) return;
            live.innerHTML = found.outerHTML;
            fallback.hidden = true;
            input.setAttribute('aria-expanded', 'true');
          })
          .catch(function () {});
      }, 160);
    });

    if (clear) clear.addEventListener('click', function () {
      input.value = '';
      clear.hidden = true;
      reset();
      input.focus();
    });

    // Arrow keys move between the input and the results, as on Apple's search.
    function visibleLinks() {
      return Array.prototype.filter.call(results.querySelectorAll('a'), function (a) { return a.offsetParent !== null; });
    }
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown') return;
      var links = visibleLinks();
      if (links[0]) { e.preventDefault(); links[0].focus(); }
    });
    results.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var links = visibleLinks();
      var i = links.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      var next = e.key === 'ArrowDown' ? i + 1 : i - 1;
      if (next < 0) input.focus();
      else if (links[next]) links[next].focus();
    });
  }
  initSearch();
  document.addEventListener('shopify:section:load', initSearch);

  /* ---------- recently viewed: record this product ---------- */
  var record = $('[data-rv-record]');
  if (record) {
    try {
      var handle = record.getAttribute('data-rv-record');
      var list = JSON.parse(localStorage.getItem(RV_KEY) || '[]').filter(function (h) { return h && h !== handle; });
      list.unshift(handle);
      localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }
})();
